/* eslint-disable react/prop-types */
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Divider from '@mui/material/Divider';
import {
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import classes from './Layout.module.css';

const APPLICATION = {
  gdd: 'Guaranteed Delivery Date Application',
  ra: 'Return Assurance Application',
  bp: 'Buyer Protection Application',
  bg: 'Buyback Guarantee Application',
  ew: 'Extended Warranty Application',
  odg: 'On-time Delivery Guarantee',
};
const IMG = {
  gdd: 'https://cdn.seel.com/assets/images/op/gdd-application-cover.svg',
  ra: 'https://cdn.seel.com/assets/images/op/ra_image.svg',
  bp: 'https://cdn.seel.com/assets/images/op/bp_image.svg',
  bg: 'https://cdn.seel.com/assets/images/op/bg_image.svg',
  ew: 'https://cdn.seel.com/assets/images/op/ew_image.svg',
  odg: 'https://cdn.seel.com/assets/images/op/odg_image.svg',
};

// const Cover = () => (
//   <div className={classes.cover}>
//     <img className={classes.cover_img} src={CoverImg} alt="" />
//   </div>
// );

export default function ApplicationLayout({
  children,
  type = 'gdd',
  extraPart,
  coverStyle,
  backHref = '/products',
  name,
  img,
}) {
  return (
    <div className={classes.container}>
      <div className={classes.left}>
        <div className={classes.navbar}>
          <Link to={backHref}>
            <div className={classes.close_button}>
              <FontAwesomeIcon className={classes.close_icon} icon={faXmark} />
            </div>
          </Link>
          <Divider sx={{ height: 12 }} orientation="vertical" />
          <div className={classes.title}>{name || APPLICATION[type]}</div>
        </div>
        <div style={{ height: '56PX' }}></div>
        <div className={classes.content}>
          {children}
        </div>
      </div>
      {/* <Cover /> */}
      <div className={classes.cover}>
        <img className={classes.cover_img} src={img || IMG[type]} alt="" style={coverStyle} />
        {extraPart}
      </div>
    </div>
  );
}
